const webpReg = new RegExp(/\.webp$/);
export const processWebp = (url = '') => url.replace(webpReg, '.jpg');
const forceJPGReg = new RegExp(/\.\w+$/);
export const forceJPG = (url: string) => `${url.replace(forceJPGReg, '')}.jpg`;

export function getImageUrl(uri: string, type = 'large', useWebp = true) {
  let _uri = uri;
  if (!_uri) {
    return _uri;
  }

  if (/^(http:|https:){0,1}\/\//.test(_uri)) {
    return _uri;
  }

  if (!_uri.includes('tos') && !_uri.includes('pgc')) {
    _uri = `tos-maliva-p-0000/${_uri}`;
  }

  _uri = `//p16-va.topbuzzcdn.com/${type}/${_uri}`;

  if (!useWebp) {
    _uri = processWebp(_uri);
  }
  // va cdn没有跨域头，先用sg的地址，记得改回来
  return _uri;
}

export const processWeirdImage = (html: string) => {
  const pattern = new RegExp(/<img src="{{image_domain}}([^>]*)">/g);
  let target = html || '';
  if (target.includes('{{image_domain}}')) {
    const targetArr = target.match(pattern) || [];
    targetArr.forEach((str: string) => {
      const innerPattern = new RegExp(/<img src="{{image_domain}}([^>]*)">/g);
      const result = innerPattern.exec(str) || [];
      const jsonStr = result[1] || '{}';
      try {
        const data = JSON.parse(jsonStr);
        // {
        //   "fingerprint": 10653165191152446867,
        //   "hash_id": 6048379742954926182,
        //   "height": 1067,
        //   "id": 7834353516823268220,
        //   "image_type": 1,
        //   "md5": "53f029549d7f306628a2e5a118989c52",
        //   "mimetype": "image/jpeg",
        //   "near_dup_id": "4372146559732556345",
        //   "neardup_id": 4372146559732556345,
        //   "uri": "pgc-image-va/RqIhXtWDUwaoSu",
        //   "url_id": 17079595278950936231,
        //   "web_uri": "pgc-image-va/RqIhXtWDUwaoSu",
        //   "width": 800
        // }
        const img = `<script type="text/x.bytedance.image">${JSON.stringify({
          width: data.width,
          height: data.height,
          description: '',
          web_uri: data.uri || data.web_uri,
        })
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')}</script>`;
        target = target.replace(str, img);
      } catch (err) {}
    });
  }

  return target;
};
